<!-- NEW DIALOG -->
@if (isDialogVisible && !severeError) {
	<p-dialog [styleClass]="authService?.user?.fontSize === 'SMALL' ? 'custom-form-small' : (authService?.user?.fontSize === 'MEDIUM' ? 'custom-form-medium' : '')"
		header="{{ vehicleFormTitle | uppercase }}"
		[(visible)]="isDialogVisible"
		[transitionOptions]="'150ms cubic-bezier(0, 0, 0.2, 1)'"
		[modal]="true"
		[draggable]="false"
		[resizable]="false"
		[closeOnEscape]="false"
		[focusOnShow]="false"
		(visibleChange)="onVisibleChange()"
		[style]="{ width: '93vw' }"
		(onShow)="onDialogShow()"
	>
	<div [ngClass]="{'custom-form-small': authService?.user?.fontSize === 'SMALL', 'custom-form-medium': authService?.user?.fontSize === 'MEDIUM'}">
		<!-- FORM ERRORS -->
		<div #errorContainer>
			@if (errorMessages.length !== 0) {
				<div>
					@for (error of errorMessages; track error) {
						<div>
							<div class="alert alert-warning" role="alert">{{ error }}</div>
						</div>
					}
				</div>
			}
		</div>
		<!-- PANELL DADES DE VEHICLE -->
		<div class="d-flex flex-column gap-3 p-3">
			<p-panel header="{{ 'tableManagement.vehicle.vehicleData' | translate }}" class="w-100 vehicle-form-panel">
				<!-- SECCION 1: vehiculo -->
				<div class="row row-cols-1 row-cols-md-2 row-cols-xl-4 g-3">
					<!-- matricula -->
					<div class="col">
						<form-input
							[required]="true"
							[align]="'stacked'"
							fieldName="{{ 'control-panel.vehicles.licensePlate' | translate }}"
						>
							<div class="d-flex align-items-center gap-3">
								@if (!isNew) {
									<i
										[attr.class]="nameLocked ? 'pi pi-lock' : 'pi pi-unlock'"
										style="cursor: pointer;"
										(click)="onChangeNameLockStatus()"
									></i>
								}
								<input
									pInputText
									[(ngModel)]="selectedVehicle.name"
									[readonly]="nameLocked"
									[style]="nameLocked ? { width: '260px', backgroundColor: '#F5F5F5' } : { width: '260px' }"
								/>
							</div>
						</form-input>
					</div>
					<!-- marca -->
					<div class="col">
						<form-input
							[required]="true"
							[align]="'stacked'"
							fieldName="{{ 'tableManagement.brands.brand' | translate }}"
						>
							<div class="d-flex align-items-center gap-2 w-100">
								<p-select
									[options]="brandList"
									[(ngModel)]="selectedBrand"
									placeholder="{{ 'general.select' | translate }} {{ 'tableManagement.brands.brand' | translate }}"
									dataKey="id"
									optionLabel="name"
									[style]="{ flex: '1 1 auto' }"
									[disabled]="!isBrandLoaded || isEditingDisabled || !isSaveGranted"
									appendTo="body"
									(onChange)="onChangeBrand($event)"
									filter="true"
									filterBy="name"
								>
								</p-select>
								@if (isSaveGranted) {
									<button class="btn custom-expand-button" type="button" i18n-alt alt="{{'control-panel.vehicles.addBrand' | translate}}" (click)="addBrand()">
										<svg-icon
											[disabled]="isEditingDisabled || !isSaveGranted"
											class="d-flex m-0 p-0 custom-expand-button-icon"
											src="assets/icons/add.svg"
											[svgStyle]="{ 'height.px': 30, 'width.px': 30 }"
										></svg-icon>
									</button>
								}
								@if (logoImageUrl) {
									<img
										id="uploadImageIcon"
										alt=""
										src="{{ logoImageUrl }}"
										class="img-responsive"
										[style]="{ 'max-height': '40px', width: '40px' }"
									/>
								}
								@if (selectedBrand?.logo?.imageEncoded) {
									<img
										id="uploadedImage"
										alt=""
										[src]="logoEncodedImage"
										class="img-responsive"
										[style]="{ 'max-height': '40px', width: '40px' }"
									/>
								}
							</div>
						</form-input>
					</div>
					<!-- model -->
					<div class="col">
						<form-input
							[required]="true"
							[align]="'stacked'"
							fieldName="{{ 'tableManagement.models.model' | translate }}"
						>
							<div class="d-flex align-items-center gap-2 w-100">
								<p-select
									[options]="modelList"
									[(ngModel)]="selectedModel"
									placeholder="{{ 'general.select' | translate }} {{ 'tableManagement.models.model' | translate }}"
									dataKey="id"
									optionLabel="name"
									[style]="{ flex: '1 1 auto' }"
									[disabled]="!isModelLoaded || isEditingDisabled || !isSaveGranted"
									appendTo="body"
									(onChange)="onChangeModel($event)"
									filter="true"
									filterBy="name"
								>
								</p-select>
								@if (isSaveGranted) {
									<button class="btn custom-expand-button" type="button" i18n-alt alt="{{'control-panel.vehicles.addModel' | translate}}" (click)="addModel()">
										<svg-icon
											[disabled]="isEditingDisabled"
											class="d-flex m-0 p-0 custom-expand-button-icon"
											src="assets/icons/add.svg"
											[svgStyle]="{ 'height.px': 30, 'width.px': 30 }"
										></svg-icon>
									</button>
								}
							</div>
						</form-input>
					</div>
					<!-- VERSION -->
					<div class="col">
						<form-input
							[required]="false"
							[align]="'stacked'"
							fieldName="{{ 'tableManagement.versions.version' | translate }}"
						>
							<div class="d-flex align-items-center gap-2 w-100">
								<p-select
									[options]="versionList"
									[(ngModel)]="selectedVersion"
									placeholder="{{ 'general.select' | translate }} {{
										'tableManagement.versions.version' | translate
									}}"
									dataKey="id"
									optionLabel="name"
									[style]="{ flex: '1 1 auto' }"
									[disabled]="!isVersionLoaded || isEditingDisabled || !isSaveGranted"
									appendTo="body"
									(onChange)="onChangeVersion($event)"
									filter="true"
									filterBy="name"
								>
								</p-select>
								@if (isSaveGranted) {
									<button
										class="btn custom-expand-button"
										type="button"
										i18n-alt alt="{{'general.addModelVersion' | translate}}"
										(click)="addVersion()"
									>
										<svg-icon
											[disabled]="isEditingDisabled"
											class="d-flex m-0 p-0 custom-expand-button-icon"
											src="assets/icons/add.svg"
											[svgStyle]="{ 'height.px': 30, 'width.px': 30 }"
										></svg-icon>
									</button>
								}
							</div>
						</form-input>
					</div>
					@if (brandSpinner) {
						<div class="col-12 d-flex">
							<mat-spinner [diameter]="30" strokeWidth="5" [color]="primary"> </mat-spinner>
						</div>
					}
				</div>
				<hr class="mt-4" />
				<!----------------------------------------------------------------------------------------------->
				<!-- SECCION 2: foto y datos del vehiculo -->
				<div class="row row-cols-1 row-cols-md-2 row-cols-xl-3 g-3">
					<!-- FOTO -->
					<div class="col d-flex align-items-center">
						<button id="uploadImageButton" (click)="uploadImageInput.click()">
							@if (vehicleImageUrl) {
								<img
									id="uploadImageIcon"
									class="ps-3"
									alt=""
									src="{{ vehicleImageUrl }}"
									class="img-responsive"
									[style]="{ 'max-height': '200px;', width: '200px', 'margin-right': '10px' }"
								/>
							}
							@if (vehicleEncodedImage) {
								<img
									id="uploadedImage"
									class="ps-3"
									alt=""
									[src]="vehicleEncodedImage"
									class="img-responsive"
									[style]="{ 'max-height': '200px;', width: '200px', 'margin-right': '10px' }"
								/>
							}
						</button>
						<input
							#uploadImageInput
							[hidden]="true"
							[disabled]="isEditingDisabled"
							type="file"
							accept=".jpg, .png"
							(change)="onImageChange($event)"
						/>
					</div>
					<!-- fleet -->
					<div class="col">
						<form-input
							[required]="true"
							[align]="'stacked'"
							fieldName="{{ 'real-time.vehiclePanel.settings.fleetName' | translate }}"
						>
							<p-select
								[options]="fleetList"
								[(ngModel)]="selectedFleet"
								i18n-placeholder placeholder="{{'general.selectPlaceholder' | translate}}"
								dataKey="id"
								optionLabel="name"
								[style]="{ width: '100%' }"
								appendTo="body"
								filter="true"
								filterBy="name"
								(onChange)="onChangeFleet($event)"
								[disabled]="isEditingDisabled || !isSaveGranted"
							>
							</p-select>
						</form-input>
					</div>
					<!-- vehicleGroup -->
					<div class="col">
						<form-input
							[required]="true"
							[align]="'stacked'"
							fieldName="{{ 'real-time.vehiclePanel.settings.vehicleGroup' | translate }}"
						>
							<p-select
								[options]="vehicleGroupList"
								[(ngModel)]="selectedVehicle.group"
								i18n-placeholder placeholder="{{'general.selectPlaceholder' | translate}}"
								dataKey="id"
								optionLabel="name"
								[style]="{ width: '100%' }"
								appendTo="body"
								filter="true"
								filterBy="name"
								(onChange)="onChangeVehicleGroup($event)"
								[disabled]="isEditingDisabled || !isSaveGranted"
							>
							</p-select>
						</form-input>
					</div>
					<!-- FECHA ALTA -->
					<div class="col">
						<form-input [align]="'stacked'" fieldName="Fecha alta">
							<p-datepicker
								appendTo="body"
								[(ngModel)]="selectedVehicle.dateRegistered"
								dateFormat="dd/mm/yy"
								showIcon="true"
								showOnFocus="false"
								[style]="{ width: '100%' }"
								[firstDayOfWeek]="1"
								[disabled]="false"
							></p-datepicker>
						</form-input>
					</div>
					<!-- REPLACED VEHICLE-->
					<div class="col">
						<form-input
							[align]="'stacked'"
							fieldName="{{ 'tableManagement.financing.replacedVehicle' | translate }}"
						>
							<input
								pInputText
								[ngModel]="selectedVehicle.replacedVehicle?.name"
								[disabled]="true"
								[style]="{ width: '100%' }"
							/>
						</form-input>
					</div>
					<!-- Bastidor -->
					<div class="col">
						<form-input
							[required]="false"
							[align]="'stacked'"
							fieldName="{{ 'control-panel.vehicles.frameNumber' | translate }}"
						>
							<input
								pInputText
								[(ngModel)]="selectedVehicle.frameNumber"
								[disabled]="isEditingDisabled || !isSaveGranted"
								[style]="{ width: '100%' }"
							/>
						</form-input>
					</div>
					<!-- Color -->
					<div class="col">
						<form-input
							[required]="false"
							[align]="'stacked'"
							fieldName="{{ 'tableManagement.vehicleStatus.table.color' | translate }}"
						>
							<input
								pInputText
								[(ngModel)]="selectedVehicle.color"
								[disabled]="isEditingDisabled || !isSaveGranted"
								[style]="{ width: '100%' }"
							/>
						</form-input>
					</div>
					<!-- Status -->
					@if (isVehicleStateGranted) {
						<div class="col">
							<form-input
								[required]="true"
								[align]="'stacked'"
								fieldName="{{ 'tableManagement.vehicleStatus.vehicleStatus' | translate }}"
							>
								<p-select
									[options]="statusList"
									[(ngModel)]="selectedVehicleStatus"
									[placeholder]="statusPlacehodler"
									dataKey="id"
									optionLabel="name"
									[style]="{ width: '100%' }"
									appendTo="body"
									[disabled]="isEditingDisabled || !isSaveGranted"
								>
								</p-select>
							</form-input>
						</div>
					}
					<!-- VehicleUsage -->
					<div class="col">
						<form-input
							[required]="true"
							[align]="'stacked'"
							fieldName="{{ 'tableManagement.vehicleUsage.vehicleUsage' | translate }}"
						>
							<p-select
								[options]="vehicleUsageList"
								[(ngModel)]="selectedVehicle.usage"
								i18n-placeholder placeholder="{{'general.selectPlaceholder' | translate}}"
								dataKey="id"
								optionLabel="name"
								[style]="{ width: '100%' }"
								appendTo="body"
								filter="true"
								filterBy="name"
								(onChange)="onChangeVehicleUsage($event)"
								[disabled]="isEditingDisabled || !isSaveGranted"
							>
							</p-select>
						</form-input>
					</div>
					<!-- renting + pay roll affected -->
					<div class="col d-flex align-items-center gap-4">
						<form-input
							[required]="false"
							[align]="'stacked'"
							fieldName="{{ 'tableManagement.vehicle.renting' | translate }}"
						>
							<p-toggleSwitch #toggle [(ngModel)]="selectedVehicle.renting" class="p-1"> </p-toggleSwitch>
						</form-input>
						@if (isVehicleStateGranted) {
							<form-input
								[required]="false"
								[align]="'stacked'"
								fieldName="{{ 'tableManagement.vehicle.payrollaffected' | translate }}"
							>
								<p-toggleSwitch
									#toggle
									[(ngModel)]="selectedVehicle.payRollAffected"
									class="p-1"
									[disabled]="isEditingDisabled"
								>
								</p-toggleSwitch>
							</form-input>
						}
					</div>
					<!-- Observacions -->
					@if (isObservationsGranted) {
						<div class="col">
							<form-input
								[required]="false"
								[align]="'stacked'"
								fieldName="{{ 'general.observations' | translate }}"
							>
								<textarea
									pInputTextarea
									id="observations"
									[(ngModel)]="selectedVehicle.observations"
									[rows]="2"
									[style]="{ width: '100%' }"
									[disabled]="isEditingDisabled"
								>
								</textarea>
							</form-input>
						</div>
					}
					<!-- disabled -->
					<div class="w-100"></div>
					<div class="col">
						<form-input
							[required]="false"
							[align]="'stacked'"
							fieldName="{{ 'tableManagement.vehicle.disabled' | translate }}"
						>
							<div class="d-flex align-items-center gap-2 w-100">
								<p-datepicker
									appendTo="body"
									[(ngModel)]="selectedVehicle.disabledDate"
									dateFormat="dd/mm/yy"
									showIcon="true"
									[style]="{ 'flex': '1 1 auto' }"
									[disabled]="isEditingDisabled"
									[firstDayOfWeek]="1"
									[disabled]="selectedVehicle.enabled"
								></p-datepicker>
								<p-toggleSwitch
									#toggle
									[ngModel]="!selectedVehicle.enabled"
									(onChange)="toggleDisabled($event)"
									class="p-1"
									[disabled]="isEditingDisabled || !isSaveGranted"
								>
								</p-toggleSwitch>
							</div>
						</form-input>
					</div>
					<!-- km -->
					@if (!selectedVehicle.enabled) {
						<div class="col">
							<form-input
								[required]="false"
								[align]="'stacked'"
								fieldName="{{ 'tableManagement.cardsConsumption.km' | translate }}"
							>
								<p-inputNumber
									[(ngModel)]="selectedVehicle.km"
									mode="decimal"
									locale="es-ES"
									(onKeyDown)="onKeyDownDecimal($event)"
									[style]="{ width: '100%' }"
									[disabled]="isEditingDisabled"
								></p-inputNumber>
							</form-input>
						</div>
					}
				</div>
			</p-panel>
		</div>
		<!-- PANELL ASSIGNMENT -->
		<div class="d-flex flex-column gap-3 p-3">
			<p-panel header="{{ 'vehicleAssignments.header' | translate }} (*)" class="w-100 vehicle-form-panel">
				<div class="row row-cols-1 row-cols-md-2 row-cols-xl-3 g-3">
					@if (assignmentSpinner) {
						<div class="col-12 d-flex">
							<mat-spinner [diameter]="30" strokeWidth="5" [color]="primary"> </mat-spinner>
						</div>
					}
					@if (!assignmentSpinner && !showAssignmentForm) {
						<div class="col-12 d-flex flex-column">
							<div class="p-2 align-items-center">
								{{ 'tableManagement.noAssignment' | translate }}
							</div>
							<div class="p-2 align-items-center">
								<app-table-add-button
									[disabled]="isEditingDisabled"
									[text]="'vehicleAssignments.assignment' | translate"
									(btnClick)="onAddAssignment()"
								></app-table-add-button>
							</div>
						</div>
					}
					@if (!assignmentSpinner && showAssignmentForm) {
						<!-- BillingAccount -->
						<div class="col-12 col-xl-6">
							<form-input
								[required]="true"
								[align]="'stacked'"
								fieldName="{{ 'tableManagement.companies.company' | translate }}"
							>
								<!-- <input pInputText [readonly]="true" [(ngModel)]='vehicleAssignment.company.code'	[style]="{'width':'100px', 'margin-right':'5px'}"/>
                              <input pInputText [readonly]="true" [(ngModel)]='vehicleAssignment.company.name'	[style]="{'width':'250px'}"/> -->
								<div class="d-flex align-items-center gap-2 w-100">
									<p-select
										[options]="billingAccountList"
										[(ngModel)]="selectedBillingAccount"
										i18n-placeholder placeholder="{{'general.selectPlaceholder' | translate}}"
										dataKey="id"
										optionLabel="code"
										[style]="{ flex: '0 0 150px' }"
										appendTo="body"
										filter="true"
										filterBy="code"
										(onChange)="onChangeBillingAccount($event)"
										[disabled]="isEditingDisabled || !isSaveGranted"
									>
									</p-select>
									<p-select
										[options]="billingAccountList"
										[(ngModel)]="selectedBillingAccount"
										i18n-placeholder placeholder="{{'general.selectPlaceholder' | translate}}"
										dataKey="id"
										optionLabel="name"
										[style]="{ flex: '1 1 auto' }"
										appendTo="body"
										filter="true"
										filterBy="name"
										(onChange)="onChangeBillingAccount($event)"
										[disabled]="isEditingDisabled || !isSaveGranted"
									>
									</p-select>
									@if (!billingAccountsMatch) {
										<i
											class="pi pi-exclamation-triangle p-2"
											style="font-size: 1.5rem; color: var(--primaryRed)"
											pTooltip="{{ 'drivers.form.driversAndVehiclesCodesNotMatching' | translate }}"
											tooltipPosition="top"
										>
										</i>
										<p-toggleSwitch
											[(ngModel)]="showMatchingWarning"
											(onChange)="toggleWarningVisibility()"
											class="p-1"
										></p-toggleSwitch>
									}
								</div>
							</form-input>
						</div>
						<!-- Delegation -->
						<div class="col-12 col-xl-6">
							<form-input
								[required]="true"
								[align]="'stacked'"
								fieldName="{{ 'tableManagement.delegations.delegation' | translate }}"
							>
								<div class="d-flex align-items-center gap-2 w-100">
									<p-select
										[options]="delegationList"
										[(ngModel)]="selectedDelegation"
										i18n-placeholder placeholder="{{'general.selectPlaceholder' | translate}}"
										dataKey="id"
										optionLabel="code"
										[style]="{ flex: '0 0 150px' }"
										appendTo="body"
										filter="true"
										filterBy="code"
										(onChange)="onChangeDelegation($event)"
										[disabled]="isEditingDisabled || !isSaveGranted"
									>
									</p-select>
									<p-select
										[options]="delegationList"
										[(ngModel)]="selectedDelegation"
										i18n-placeholder placeholder="{{'general.selectPlaceholder' | translate}}"
										dataKey="id"
										optionLabel="name"
										[style]="{ flex: '1 1 auto' }"
										appendTo="body"
										filter="true"
										filterBy="name"
										(onChange)="onChangeDelegation($event)"
										[disabled]="isEditingDisabled || !isSaveGranted"
									>
									</p-select>
									@if (selectedDelegation !== null && delegationList !== null && isSaveGranted) {
										<button
											class="btn custom-expand-button"
											type="button"
											i18n-alt alt="{{'general.remove' | translate}}"
											(click)="onRemoveDelegation()"
										>
											<svg-icon
												[disabled]="isEditingDisabled || !isSaveGranted"
												[ngClass]="{ rotated: !expanded }"
												class="d-flex m-0 p-0 custom-expand-button-icon"
												src="assets/icons/remove.svg"
												[svgStyle]="{ 'height.px': 30, 'width.px': 30 }"
											></svg-icon>
										</button>
									}
								</div>
							</form-input>
						</div>
						<!-- Sub-Delegation -->
						<div class="col-12 col-xl-6">
							<form-input
								[required]="false"
								[align]="'stacked'"
								fieldName="{{ 'tableManagement.subdelegations.subdelegation' | translate }}"
							>
								<div class="d-flex align-items-center gap-2 w-100">
									<p-select
										[options]="subdelegationList"
										[(ngModel)]="selectedSubdelegation"
										i18n-placeholder placeholder="{{'general.selectPlaceholder' | translate}}"
										dataKey="id"
										optionLabel="code"
										[style]="{ flex: '0 0 150px' }"
										appendTo="body"
										filter="true"
										filterBy="code"
										[disabled]="!isSubdelegationListLoaded || isEditingDisabled || !isSaveGranted"
										(onChange)="onChangeSubDelegation($event)"
									>
									</p-select>
									<p-select
										[options]="subdelegationList"
										[(ngModel)]="selectedSubdelegation"
										i18n-placeholder placeholder="{{'general.selectPlaceholder' | translate}}"
										dataKey="id"
										optionLabel="name"
										[style]="{ flex: '1 1 auto' }"
										appendTo="body"
										filter="true"
										filterBy="name"
										[disabled]="!isSubdelegationListLoaded || isEditingDisabled || !isSaveGranted"
										(onChange)="onChangeSubDelegation($event)"
									>
									</p-select>
									@if (selectedSubdelegation !== null && subdelegationList !== null && isSaveGranted) {
										<button
											class="btn custom-expand-button"
											type="button"
											i18n-alt alt="{{'general.remove' | translate}}"
											(click)="onRemoveSubDelegation()"
										>
											<svg-icon
												[disabled]="isEditingDisabled || !isSaveGranted"
												[ngClass]="{ rotated: !expanded }"
												class="d-flex m-0 p-0 custom-expand-button-icon"
												src="assets/icons/remove.svg"
												[svgStyle]="{ 'height.px': 30, 'width.px': 30 }"
											></svg-icon>
										</button>
									}
								</div>
							</form-input>
						</div>
						<!-- Ceco -->
						<div class="col-12 col-xl-6">
							<form-input
								[required]="true"
								[align]="'stacked'"
								fieldName="{{ 'drivers.table.ceco' | translate }}"
							>
								<div class="d-flex align-items-center gap-2 w-100">
									<p-select
										[options]="cecoList"
										[(ngModel)]="selectedCeco"
										i18n-placeholder placeholder="{{'general.selectPlaceholder' | translate}}"
										dataKey="id"
										optionLabel="code"
										[style]="{ flex: '0 0 150px' }"
										appendTo="body"
										filter="true"
										filterBy="code"
										[disabled]="!isCecoListLoaded || isEditingDisabled || !isSaveGranted"
										(onChange)="onChangeCeco($event)"
									>
									</p-select>
									<p-select
										[options]="cecoList"
										[(ngModel)]="selectedCeco"
										i18n-placeholder placeholder="{{'general.selectPlaceholder' | translate}}"
										dataKey="id"
										optionLabel="description"
										[style]="{ flex: '1 1 auto' }"
										appendTo="body"
										filter="true"
										filterBy="description"
										[disabled]="!isCecoListLoaded || isEditingDisabled || !isSaveGranted"
										(onChange)="onChangeCeco($event)"
									>
									</p-select>
									@if (selectedCeco !== null && cecoList !== null && isSaveGranted) {
										<button
											class="btn custom-expand-button"
											type="button"
											i18n-alt alt="{{'general.remove' | translate}}"
											(click)="onRemoveCeco()"
										>
											<svg-icon
												[disabled]="isEditingDisabled || !isSaveGranted"
												[ngClass]="{ rotated: !expanded }"
												class="d-flex m-0 p-0 custom-expand-button-icon"
												src="assets/icons/remove.svg"
												[svgStyle]="{ 'height.px': 30, 'width.px': 30 }"
											></svg-icon>
										</button>
									}
								</div>
							</form-input>
						</div>
						<!-- Responsable flota -->
						<div class="col-12 col-md-6 col-xl-4">
							<form-input
								[required]="false"
								[align]="'stacked'"
								fieldName="{{ 'tableManagement.delegations.fleetManager' | translate }}"
							>
								<div class="d-flex align-items-center gap-2 w-100">
									@if (fleetManagerImageUrl) {
										<img
											[disabled]="isEditingDisabled || !isSaveGranted"
											id="fleetManagerImageIcon"
											alt=""
											src="{{ fleetManagerImageUrl }}"
											class="img-responsive"
											[style]="{ 'max-height': '50px;', width: '50px' }"
										/>
									}
									@if (fleetManager !== null && fleetManager.profileImage?.imageEncoded) {
										<img
											[disabled]="isEditingDisabled || !isSaveGranted"
											id="fleetManagerImageUrl"
											alt=""
											[src]="fleetManagerImage"
											class="img-responsive"
											[style]="{ 'max-height': '50px;', width: '50px' }"
										/>
									}
									<p-select
										[options]="fleetManagerList"
										[(ngModel)]="fleetManager"
										[placeholder]="fleetManagerPlaceHolder"
										dataKey="id"
										optionLabel="formatResponsibleLabel"
										[style]="{ flex: '1 1 auto' }"
										appendTo="body"
										[filter]="true"
										filterBy="formatResponsibleLabel"
										[virtualScroll]="true"
										[virtualScrollItemSize]="50"
										[disabled]="isEditingDisabled || !isSaveGranted"
										(onChange)="onCustomFleetManager($event)"
									>
									</p-select>
									<button
										type="button"
										class="btn custom-expand-button"
										(click)="onCustomUndo('fleetManager')"
										[disabled]="isEditingDisabled"
									>
										@if (customFleetManager) {
											<svg-icon
												[ngClass]="{ rotated: !expanded }"
												pTooltip="{{ 'general.customIcon' | translate }}"
												class="d-flex m-0 p-0 custom-expand-button-icon"
												src="assets/icons/custom.svg"
												[svgStyle]="{ 'height.px': 30, 'width.px': 30, 'fill-opacity': 0.4 }"
												[disabled]="true"
											></svg-icon>
										}
									</button>
								</div>
							</form-input>
						</div>
						<!-- Responsable serveis -->
						<div class="col-12 col-md-6 col-xl-4">
							<form-input
								[required]="false"
								[align]="'stacked'"
								fieldName="{{ 'tableManagement.delegations.serviceManager' | translate }}"
							>
								<div class="d-flex align-items-center gap-2 w-100">
									@if (serviceManagerImageUrl) {
										<img
											[disabled]="isEditingDisabled || !isSaveGranted"
											id="serviceManagerImageIcon"
											alt=""
											src="{{ serviceManagerImageUrl }}"
											class="img-responsive"
											[style]="{ 'max-height': '50px;', width: '50px' }"
										/>
									}
									@if (serviceManager !== null && serviceManager.profileImage?.imageEncoded) {
										<img
											[disabled]="isEditingDisabled || !isSaveGranted"
											id="serviceManagerImageUrl"
											alt=""
											[src]="serviceManagerImage"
											class="img-responsive"
											[style]="{ 'max-height': '50px;', width: '50px' }"
										/>
									}
									<p-select
										[options]="serviceManagerList"
										[(ngModel)]="serviceManager"
										[style]="{ flex: '1 1 auto' }"
										[placeholder]="serviceManagerPlaceHolder"
										[filter]="true"
										appendTo="body"
										[virtualScroll]="true"
										[virtualScrollItemSize]="50"
										dataKey="id"
										optionLabel="formatResponsibleLabel"
										filterBy="formatResponsibleLabel"
										[disabled]="isEditingDisabled || !isSaveGranted"
										(onChange)="onCustomServiceManager($event)"
									>
									</p-select>
									<button
										type="button"
										class="btn custom-expand-button"
										(click)="onCustomUndo('serviceManager')"
										[disabled]="isEditingDisabled"
									>
										@if (customServiceManager) {
											<svg-icon
												[ngClass]="{ rotated: !expanded }"
												pTooltip="{{ 'general.customIcon' | translate }}"
												class="d-flex m-0 p-0 custom-expand-button-icon"
												src="assets/icons/custom.svg"
												[svgStyle]="{ 'height.px': 30, 'width.px': 30, 'fill-opacity': 0.4 }"
												[disabled]="true"
											></svg-icon>
										}
									</button>
								</div>
							</form-input>
						</div>
						<!-- Lider de zona -->
						<div class="col-12 col-md-6 col-xl-4">
							<form-input
								[required]="false"
								[align]="'stacked'"
								fieldName="{{ 'tableManagement.delegations.zoneChief' | translate }}"
							>
								<div class="d-flex align-items-center gap-2 w-100">
									@if (zoneLeaderImageUrl) {
										<img
											[disabled]="isEditingDisabled || !isSaveGranted"
											id="zoneLeaderImageIcon"
											alt=""
											src="{{ zoneLeaderImageUrl }}"
											class="img-responsive"
											[style]="{ 'max-height': '50px;', width: '50px' }"
										/>
									}
									@if (zoneLeader !== null && zoneLeader.profileImage?.imageEncoded) {
										<img
											[disabled]="isEditingDisabled || !isSaveGranted"
											id="zoneLeaderImageUrl"
											alt=""
											[src]="zoneLeaderImage"
											class="img-responsive"
											[style]="{ 'max-height': '50px;', width: '50px' }"
										/>
									}
									<p-select
										[options]="zoneLeaderList"
										[(ngModel)]="zoneLeader"
										[style]="{ flex: '1 1 auto' }"
										[placeholder]="zoneLeaderPlaceHolder"
										[filter]="true"
										appendTo="body"
										[virtualScroll]="true"
										[virtualScrollItemSize]="50"
										dataKey="id"
										optionLabel="formatResponsibleLabel"
										filterBy="formatResponsibleLabel"
										[disabled]="isEditingDisabled || !isSaveGranted"
										(onChange)="onCustomZoneLeader($event)"
									>
									</p-select>
									<button
										type="button"
										class="btn custom-expand-button"
										(click)="onCustomUndo('zoneLeader')"
										[disabled]="isEditingDisabled"
									>
										@if (customZoneLeader) {
											<svg-icon
												[ngClass]="{ rotated: !expanded }"
												pTooltip="{{ 'general.customIcon' | translate }}"
												class="d-flex m-0 p-0 custom-expand-button-icon"
												src="assets/icons/custom.svg"
												[svgStyle]="{ 'height.px': 30, 'width.px': 30, 'fill-opacity': 0.4 }"
												[disabled]="true"
											></svg-icon>
										}
									</button>
								</div>
							</form-input>
						</div>
						<!-- Gestor (responsible) -->
						<div class="col-12 col-md-6 col-xl-4">
							<form-input
								[required]="false"
								[align]="'stacked'"
								fieldName="{{ 'tableManagement.fine.responsible' | translate }}"
							>
								<p-select
									[options]="fleetManagerList"
									[(ngModel)]="selectedVehicle.responsible"
									[ngModelOptions]="{ standalone: true }"
									placeholder="{{ 'general.select' | translate }}..."
									dataKey="id"
									optionLabel="formatResponsibleLabel"
									[style]="{ width: '100%' }"
									appendTo="body"
									[filter]="true"
									filterBy="formatResponsibleLabel"
									[showClear]="true"
									[disabled]="isEditingDisabled || !isSaveGranted"
								>
								</p-select>
							</form-input>
						</div>
						<!-- IVA -->
						<div class="col-12 col-md-6 col-xl-4">
							<form-input [required]="true" [align]="'stacked'" fieldName="IVA">
								<!-- <input pInputText [readonly]="false" [(ngModel)]='vehicleAssignment.iva' [style]="{'width':'150px'}"/> -->
								<div class="d-flex align-items-center gap-2 w-100">
									<p-select
										[options]="ivaTypesList"
										[(ngModel)]="selectedIva"
										i18n-placeholder placeholder="{{'general.selectPlaceholder' | translate}}"
										[style]="{ flex: '0 0 120px' }"
										appendTo="body"
										[disabled]="isEditingDisabled || !isSaveGranted"
									>
										<ng-template let-iva pTemplate="selectedItem">
											{{ iva.replace('P', '') }}
										</ng-template>
										<ng-template let-iva pTemplate="item">
											{{ iva.replace('P', '') }}
										</ng-template>
									</p-select>
									@if (selectedIva !== null && ivaTypesList !== null && isSaveGranted) {
										<button
											class="btn custom-expand-button"
											type="button"
											i18n-alt alt="{{'general.remove' | translate}}"
											(click)="onRemoveIva()"
										>
											<svg-icon
												[disabled]="isEditingDisabled || !isSaveGranted"
												[ngClass]="{ rotated: !expanded }"
												class="d-flex m-0 p-0 custom-expand-button-icon"
												src="assets/icons/remove.svg"
												[svgStyle]="{ 'height.px': 30, 'width.px': 30 }"
											></svg-icon>
										</button>
									}
								</div>
							</form-input>
						</div>
						<!-- Data d'assignaciÃ³ de vehicle -->
						<div class="col-12 col-md-6 col-xl-4">
							<form-input
								[required]="false"
								[align]="'stacked'"
								fieldName="{{ 'documents.table.date' | translate }}"
							>
								<div class="d-flex align-items-center gap-2 w-100">
									<p-datepicker
										appendTo="body"
										[(ngModel)]="dateVehicleAssignment"
										dateFormat="{{ i18n.dateFormat }}"
										[minDate]="minDateVehicleAssignment"
										showIcon="true"
										[style]="{ flex: '0 0 190px' }"
										[disabled]="dateVehicleAssignmentDisabled || isEditingDisabled"
									>
									</p-datepicker>
									@if (selectedVehicle?.pendingVehicleAssignments?.some(a => !a.status)) {
										<button
											pButton
											type="button"
											icon="pi pi-clock"
											class="p-button-warning p-button-rounded"
											[pTooltip]="'tableManagement.vehicleAssignment.pendingAssignments' | translate"
											tooltipPosition="top"
											(click)="showPendingVehicleAssignmentsDialog = true"
										></button>
									}
								</div>
							</form-input>
						</div>
					}
				</div>
			</p-panel>
		</div>
		<!-- PANELL CONDUCTOR + ASSIGNMENT -->
		<div class="d-flex flex-column gap-3 p-3">
			<p-panel
				header="{{ 'drivers.header' | translate }}"
				class="w-100 vehicle-form-panel"
				[ngClass]="{ 'my-custom-panel': selectedDriver?.disabled }"
			>
				<div class="row row-cols-1 row-cols-md-2 row-cols-xl-3 g-3">
					@if (driverSpinner) {
						<div class="col-12 d-flex">
							<mat-spinner [diameter]="30" strokeWidth="5" [color]="primary"> </mat-spinner>
						</div>
					}
					@if (!driverSpinner && !showDriverForm) {
						<div class="col-12 d-flex flex-column">
							<div class="p-2">
								{{ 'tableManagement.noDriver' | translate }}
							</div>
							<div class="p-2 align-items-center">
								<app-table-add-button
									[disabled]="isEditingDisabled"
									[text]="'drivers.header' | translate"
									(btnClick)="onAddDriver()"
								></app-table-add-button>
							</div>
						</div>
					}
					@if (!driverSpinner && showDriverForm) {
						<!-- Driver -->
						<div class="col-12 col-md-6 col-xl-4">
							<form-input
								[required]="false"
								[align]="'stacked'"
								fieldName="{{ 'drivers.header' | translate }}"
							>
								@if (!billingAccountsMatch) {
									<i
										form-input-label-end
										class="pi pi-exclamation-triangle"
										style="font-size: 1.1rem; color: var(--primaryRed)"
										pTooltip="{{ 'drivers.form.driversAndVehiclesCodesNotMatching' | translate }}"
										tooltipPosition="top"
									></i>
								}
								<div class="d-flex align-items-center gap-2 w-100">
									<input
										pInputText
										[pTooltip]="selectedDriver?.fullName"
										[disabled]="isEditingDisabled"
										[readonly]="true"
										[ngModel]="selectedDriver?.fullName"
										(ngModelChange)="selectedDriver.fullName = $event"
										[style]="{ flex: '1 1 auto' }"
									/>
									<div class="d-flex align-items-center gap-1">
										@if (isChangeDriverGranted) {
											<button
												class="btn custom-expand-button"
												type="button"
												i18n-alt alt="{{'general.select' | translate}}"
												(click)="onSelectDriver()"
												[disabled]="isEditingDisabled"
											>
												<svg-icon
													[ngClass]="{ rotated: !expanded }"
													class="d-flex m-0 p-0 custom-expand-button-icon"
													src="assets/icons/arrow_select.svg"
													[svgStyle]="{ 'height.px': 30, 'width.px': 30 }"
												></svg-icon>
											</button>
										}
										@if (selectedDriver !== null && isChangeDriverGranted) {
											<button
												class="btn custom-expand-button"
												type="button"
												i18n-alt alt="{{'general.remove' | translate}}"
												(click)="onRemoveDriver()"
												[disabled]="isEditingDisabled"
											>
												<svg-icon
													[ngClass]="{ rotated: !expanded }"
													class="d-flex m-0 p-0 custom-expand-button-icon"
													src="assets/icons/remove.svg"
													[svgStyle]="{ 'height.px': 30, 'width.px': 30 }"
												></svg-icon>
											</button>
										}
									</div>
								</div>
							</form-input>
						</div>
						<!-- Empresa -->
						@if (selectedDriver !== null) {
							<div class="col-12 col-md-6 col-xl-4">
								<form-input
									[required]="false"
									[align]="'stacked'"
									fieldName="{{ 'drivers.table.company' | translate }}"
								>
									{{ selectedDriver.employee.ceco?.billingAccount?.code }} -
									{{ selectedDriver.employee.ceco?.billingAccount?.name }}
								</form-input>
							</div>
						}
						<!-- Division -->
						@if (selectedDriver !== null) {
							<div class="col-12 col-md-6 col-xl-4">
								<form-input
									[required]="false"
									[align]="'stacked'"
									fieldName="{{ 'drivers.table.division' | translate }}"
								>
									{{ selectedDriver.employee.subdivision?.division?.code }} -
									{{ selectedDriver.employee.subdivision?.division?.name }}
								</form-input>
							</div>
						}
						<!-- Sub-Division -->
						@if (selectedDriver !== null) {
							<div class="col-12 col-md-6 col-xl-4">
								<form-input
									[required]="false"
									[align]="'stacked'"
									fieldName="{{ 'drivers.table.subdivision' | translate }}"
								>
									{{ selectedDriver.employee.subdivision?.code }} -
									{{ selectedDriver.employee.subdivision?.name }}
								</form-input>
							</div>
						}
						<!-- Ceco -->
						@if (selectedDriver !== null) {
							<div class="col-12 col-md-6 col-xl-4">
								<form-input
									[required]="false"
									[align]="'stacked'"
									fieldName="{{ 'drivers.table.ceco' | translate }}"
								>
									{{ selectedDriver !== null ? selectedDriver.employee.ceco?.code : '' }} -
									{{ selectedDriver !== null ? selectedDriver.employee.ceco?.description : '' }}
								</form-input>
							</div>
						}
						<!-- Data d'assignaciÃ³ -->
						@if (selectedDriver !== null && !assignmentSpinner && showAssignmentForm) {
							<div class="col-12 col-md-6 col-xl-4">
								<form-input
									[required]="false"
									[align]="'stacked'"
									fieldName="{{ 'drivers.assignmentDate' | translate }}"
								>
									<div class="d-flex align-items-center gap-2 w-100">
										<p-datepicker
											appendTo="body"
											[(ngModel)]="dateDriverAssignment"
											dateFormat="dd/mm/yy"
											showIcon="true"
											[style]="{ flex: '0 0 190px' }"
											[disabled]="dateDriverAssignmentDisabled || isEditingDisabled"
											[firstDayOfWeek]="1"
										>
										</p-datepicker>
										@if (selectedVehicle?.pendingDriverAssignments?.some(a => !a.status)) {
											<button
												pButton
												type="button"
												icon="pi pi-clock"
												class="p-button-warning p-button-rounded"
												[pTooltip]="'tableManagement.driverAssignment.pendingAssignments' | translate"
												tooltipPosition="top"
												(click)="showPendingDriverAssignmentsDialog = true"
											></button>
										}
									</div>
								</form-input>
							</div>
						}
						<!-- km now -->
						@if (selectedDriver !== null && !assignmentSpinner && showAssignmentForm) {
							<div class="col-12 col-md-6 col-xl-4">
								<form-input
									[required]="false"
									[align]="'stacked'"
									fieldName="{{ 'drivers.lastKms' | translate }}"
								>
									<p-inputNumber
										[(ngModel)]="selectedVehicle.km"
										mode="decimal"
										locale="es-ES"
										(onKeyDown)="onKeyDownDecimal($event)"
										[style]="{ width: '190px' }"
										[disabled]="dateDriverAssignmentDisabled || isEditingDisabled"
									></p-inputNumber>
								</form-input>
							</div>
						}
						<!-- assign km -->
						@if (selectedDriver !== null && !assignmentSpinner && showAssignmentForm) {
							<div class="col-12 col-md-6 col-xl-4">
								<form-input
									[required]="false"
									[align]="'stacked'"
									fieldName="{{ 'drivers.assignKms' | translate }}"
								>
									<p-inputNumber
										[(ngModel)]="assignKms"
										mode="decimal"
										locale="es-ES"
										[style]="{ width: '190px' }"
										[disabled]="true"
									></p-inputNumber>
								</form-input>
							</div>
						}
					}
				</div>
			</p-panel>
		</div>
		<!-- Pestanyes: Manteniments / ALERTES (boto per desactivar-les totes?) / DOCUMENTACIO / NOTES-->
		@if (showTabs) {
			<div class="d-flex flex-column gap-3 p-3">
				<p-tabs class="vehicle-form-tabs" [value]="isCardGranted ? 'cards' : isFineGranted ? 'fines' : isTaxGranted ? 'taxes' : isFinancingGranted ? 'financing' : isInsuranceGranted ? 'insurances' : isDocumentGranted ? 'documents' : isAccesoryGranted ? 'accessories' : isMaintenanceGranted ? 'maintenance' : isMileageGranted ? 'mileage' : isCardConsumptionGranted ? 'cardConsumption' : isNoteGranted ? 'notes' : isSinisterGranted ? 'sinister' : 'breakdown'">
					<p-tablist>
						@if (isCardGranted) {
							<p-tab value="cards">{{ 'tableManagement.cardLists.cards' | translate }}</p-tab>
						}
						@if (isFineGranted) {
							<p-tab value="fines">{{ 'tableManagement.fine.fines' | translate }}</p-tab>
						}
						@if (isTaxGranted) {
							<p-tab value="taxes">{{ 'tableManagement.tax.taxes' | translate }}</p-tab>
						}
						@if (isFinancingGranted) {
							<p-tab value="financing">{{ 'tableManagement.financing.financing' | translate }}</p-tab>
						}
						@if (isInsuranceGranted) {
							<p-tab value="insurances">{{ 'tableManagement.insurances' | translate }}</p-tab>
						}
						@if (isDocumentGranted) {
							<p-tab value="documents">{{ 'documents.header' | translate }}</p-tab>
						}
						@if (isAccesoryGranted) {
							<p-tab value="accessories">{{ 'tableManagement.accessories.accessories' | translate }}</p-tab>
						}
						@if (isMaintenanceGranted) {
							<p-tab value="maintenance">{{ 'maintenance.header' | translate }}</p-tab>
						}
						@if (isMileageGranted) {
							<p-tab value="mileage">{{ 'tableManagement.mileage.mileage' | translate }}</p-tab>
						}
						@if (isCardConsumptionGranted) {
							<p-tab value="cardConsumption">{{ 'tableManagement.cardsConsumption.cardConsumption' | translate }}</p-tab>
						}
						@if (isNoteGranted) {
							<p-tab value="notes">{{ 'tableManagement.notes.notes' | translate }}</p-tab>
						}
						@if (isSinisterGranted) {
							<p-tab value="sinister">{{ 'tableManagement.sinister.sinister' | translate }}</p-tab>
						}
						@if (isBreakdownGranted) {
							<p-tab value="breakdown">{{ 'tableManagement.breakdown.title' | translate }}</p-tab>
						}
					</p-tablist>
					<p-tabpanels>
						<!-- CARDS -->
						@if (isCardGranted) {
							<p-tabpanel value="cards">
								<app-card-lists
									[vehicle]="selectedVehicle"
									[startDate]="startDate"
									[endDate]="endDate"
									[nested]="true"
									[showTitle]="false"
								></app-card-lists>
							</p-tabpanel>
						}
						<!-- FINES -->
						@if (isFineGranted) {
							<p-tabpanel value="fines">
								<app-fine-list
									[vehicle]="selectedVehicle"
									[startDate]="startDate"
									[endDate]="endDate"
									[nested]="true"
									[showTitle]="false"
								></app-fine-list>
							</p-tabpanel>
						}
						<!-- TAXES -->
						@if (isTaxGranted) {
							<p-tabpanel value="taxes">
								<app-taxes-list
									[vehicle]="selectedVehicle"
									[startDate]="startDate"
									[endDate]="endDate"
									[nested]="true"
									[showTitle]="false"
								></app-taxes-list>
							</p-tabpanel>
						}
						<!-- FINANCING -->
						@if (isFinancingGranted) {
							<p-tabpanel value="financing">
								<app-financing-list
									[vehicle]="selectedVehicle"
									[startDate]="startDate"
									[endDate]="endDate"
									[nested]="true"
									[showTitle]="false"
								></app-financing-list>
							</p-tabpanel>
						}
						<!-- INSURANCE -->
						@if (isInsuranceGranted) {
							<p-tabpanel value="insurances">
								<app-insurance-list
									[vehicle]="selectedVehicle"
									[startDate]="startDate"
									[endDate]="endDate"
									[nested]="true"
									[showTitle]="false"
									[showCalculateQuarterly]="false"
								></app-insurance-list>
							</p-tabpanel>
						}
						<!-- DOCUMENTS -->
						@if (isDocumentGranted) {
							<p-tabpanel value="documents">
								<app-doc-table
									[type]="'vehicle'"
									[entity]="selectedVehicle"
									[nested]="true"
									[showTitle]="false"
									[useDocNote]="true"
								></app-doc-table>
							</p-tabpanel>
						}
						<!-- ACCESSORIES -->
						@if (isAccesoryGranted) {
							<p-tabpanel value="accessories">
								<app-inventory-vehicle-accessory-list
									[vehicle]="selectedVehicle"
									[startDate]="startDate"
									[endDate]="endDate"
									[showTitle]="false"
								></app-inventory-vehicle-accessory-list>
							</p-tabpanel>
						}
						<!-- MAINTENANCE -->
						@if (isMaintenanceGranted) {
							<p-tabpanel value="maintenance">
								<app-maintenance-executions-list
									[vehicle]="selectedVehicle"
									[showTitle]="false"
								></app-maintenance-executions-list>
								<app-maintenance-execution-alert
									[vehicle]="selectedVehicle"
									[showTitle]="false"
								></app-maintenance-execution-alert>
							</p-tabpanel>
						}
						<!-- MILEAGE -->
						@if (isMileageGranted) {
							<p-tabpanel value="mileage">
								<app-mileage-list
									[vehicle]="selectedVehicle"
									[showTitle]="false"
									(saveCompleted)="refreshMileage()"
								></app-mileage-list>
							</p-tabpanel>
						}
						<!-- CARD CONSUMPTION -->
						@if (isCardConsumptionGranted) {
							<p-tabpanel value="cardConsumption">
								<app-cardConsumption-list
									[vehicle]="selectedVehicle"
									[showTitle]="false"
								></app-cardConsumption-list>
							</p-tabpanel>
						}
						<!-- NOTES -->
						@if (isNoteGranted) {
							<p-tabpanel value="notes">
								<app-notes-list
									[vehicle]="selectedVehicle"
									[showTitle]="false"
									(saveCompleted)="refreshMileage()"
								></app-notes-list>
							</p-tabpanel>
						}
						<!-- SINISTER -->
						@if (isSinisterGranted) {
							<p-tabpanel value="sinister">
								<app-sinister-list [vehicle]="selectedVehicle" [showTitle]="false"></app-sinister-list>
							</p-tabpanel>
						}
						<!-- BREAKDOWN -->
						@if (isBreakdownGranted) {
							<p-tabpanel value="breakdown">
								<app-breakdown-list [vehicle]="selectedVehicle" [showTitle]="false"></app-breakdown-list>
							</p-tabpanel>
						}
					</p-tabpanels>
				</p-tabs>
			</div>
		}
		<div class="margin"></div>
	</div>
<!-- PIE DE PAGINA -->
<ng-template pTemplate="footer">
	<div class="d-flex flex-row-reverse bd-highlight">
		<div class="p-2 bd-highlight d-flex gap-2">
			<!-- btn historic -->
			<button
				type="button"
				class="btn custom-button"
				(click)="onShowHistoric()"
				[disabled]="isEditingDisabled"
			>
				{{ 'tableManagement.vehicleHtc.getHtc' | translate }}
			</button>
			<!-- btn SAVE -->
			<button
				type="button"
				class="btn custom-button"
				(click)="onSaveVehicle()"
				[disabled]="isEditingDisabled || !isSaveGranted"
			>
				{{ isEditingDisabled ? ('general.saving' | translate) : ('general.save' | translate) }}
			</button>
		</div>
	</div>
</ng-template>
	</p-dialog>
}

<app-inventory-htc-vehicle
	(refreshDriverAssignment)="refreshDriverAssignment()"
	(refreshVehicleAssignment)="refreshVehicleAssignment()"
></app-inventory-htc-vehicle>
<app-drivers-select-list></app-drivers-select-list>

@if (showPendingVehicleAssignmentsDialog) {
	<p-dialog
		[header]="'tableManagement.vehicleAssignment.futureDateWarningHeader' | translate"
		[(visible)]="showPendingVehicleAssignmentsDialog"
		[modal]="true"
		[draggable]="false"
		[resizable]="false"
		[style]="{ width: '900px' }"
	>
		<app-pending-vehicle-assignments-list
			[vehicle]="selectedVehicle"
		></app-pending-vehicle-assignments-list>
	</p-dialog>
}

@if (showPendingDriverAssignmentsDialog) {
	<p-dialog
		[header]="'tableManagement.driverAssignment.futureDateWarningHeader' | translate"
		[(visible)]="showPendingDriverAssignmentsDialog"
		[modal]="true"
		[draggable]="false"
		[resizable]="false"
		[style]="{ width: '950px' }"
	>
		<app-pending-driver-assignments-list
			[vehicle]="selectedVehicle"
		></app-pending-driver-assignments-list>
	</p-dialog>
}

<!-- CONFIRM SAVE EVENT DIALOG -->
<p-confirmDialog
	#saveEventDialog
	[header]="'confirm.critic' | translate"
	class="custom-dialog"
	icon="pi pi-exclamation-triangle"
	key="inventory-vehicle-form"
>
	<ng-template pTemplate="footer">
		<button (click)="saveEventDialog.onReject()" class="custom-button">
			{{ 'general.no' | translate }}
		</button>
		<button (click)="saveEventDialog.onAccept()" class="custom-button">
			{{ 'general.yes' | translate }}
		</button>
	</ng-template>
</p-confirmDialog>

<p-confirmDialog
	#saveEventDialog2
	[header]="'confirm.critic' | translate"
	class="custom-dialog"
	icon="pi pi-exclamation-triangle"
	key="change-active-vehicle"
>
	<ng-template pTemplate="footer">
		<button (click)="saveEventDialog2.onReject()" class="custom-button">
			{{ 'general.no' | translate }}
		</button>
		<button (click)="saveEventDialog2.onAccept()" class="custom-button">
			{{ 'general.yes' | translate }}
		</button>
	</ng-template>
</p-confirmDialog>

<p-confirmDialog
	#saveEventDialog3
	[header]="'confirm.critic' | translate"
	class="custom-dialog"
	icon="pi pi-exclamation-triangle"
	key="change-date-driver"
>
	<ng-template pTemplate="footer">
		<button (click)="saveEventDialog3.onReject()" class="custom-button">
			{{ 'general.no' | translate }}
		</button>
		<button (click)="saveEventDialog3.onAccept()" class="custom-button">
			{{ 'general.yes' | translate }}
		</button>
	</ng-template>
</p-confirmDialog>

